import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'rocket-banner',
    templateUrl: './rocket.component.html',
    styleUrls: ['./rocket.component.css'],
    standalone: false
})
export class RocketComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
